export const hasPageSliders = () => {
  return ($(".featured-doelen__row-container").length > 0 ||
          $(".carousel-afbeeldingen__row-container").length > 0 ||
          $(".featured-acties__scroll-container").length > 0 ||
          $(".nieuwsoverzicht").length > 0 ||
          $(".eventscases").length > 0 ||
          $(".testimonial__container-wrapper").length > 0); 
};

export const initModalCarousel = () => {    
  if ($(".modal-carousel").length > 0) {
    $(".modal-carousel").each((index, element) => {
      $(element).appendTo("body");
    });
  } 
};
